import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerTitleService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_CustomerTitleDto,
} from '../../services/wealthlane-customer-services';
import { type TableParamsType } from '../../types/common';

const useGetCustomerTitleListWithPagination = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo?: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CustomerTitleDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo ?? {};
  const CustomerTitleList = useQuery(
    ['getCustomerTitleListWithPagination', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        CustomerTitleService.getApiCustomerApiAppCustomerTitleCustomerTitleList(
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return CustomerTitleList;
};

export default useGetCustomerTitleListWithPagination;
